import React, { Component } from "react";
import Table from "../../components/Common/table";
import { supplierDrawingFile } from "../../services/config.json";

class ItemDrawingDetailTable extends Component {
  columns = [
    // {
    //   path: "selected",
    //   label: " ",
    //   content: (item, index) => (
    //     <Checkbox
    //       onChange={() => this.props.handleCheckPrint(item, index)}
    //       isChecked={item.selected}
    //       id={`${index}Selected`}
    //     />
    //   )
    // },
    {
      path: "idx",
      label: "#",
      content: (customer, index) => (
        <span>{index + 1 }</span>
      ),
    },
    {
      path: "supplier_name",
      label: "Supplier",
    },
    {
      path: "drawing_category",
      label: "Kategori",
    },
    {
      path: "code",
      label: "Kode",
    },
    {
      path: "code_supplier",
      label: "Kode Supplier",
    },
    {
      path: "description",
      label: "Deskripsi",
    },
    {
      path: "drawing",
      label: "Drawing",
      content: (item, index) => (
        <React.Fragment>
          {item.is_pdf === "1" ? 
            <label style={{cursor: "pointer", textDecoration: 'underline'}} onClick={()=>this.props.handleOpenPdf(supplierDrawingFile+item.drawing)}>
              {item.drawing}
            </label>
          :
          <div className="form-group">  
            <img
              style={{
                width: "100%",
              }}
              src={
                supplierDrawingFile +
                item.drawing
              }
            />
          </div>
          }
          
        </React.Fragment>
      ),
    },
  ];

  hideAction = (column) => {
    let col = column.filter(function (obj) {
      return obj.label !== "action";
    });
    return col;
  };
  render() {
    const { drawing, from, ...rest } = this.props;
    return (
      <Table
        columns={this.columns}
        data={drawing}
        {...rest}
        keyId="id_item_supplier_drawing"
      />
    );
  }
}

export default ItemDrawingDetailTable;



// WEBPACK FOOTER //
// ./src/views/item/itemDrawingDetailTable.jsx